<template>
 <el-dialog
    title="Session Update"
    :visible="showModal"
    width="400px"
    center
    class="ts-modal"
    :show-close="false"
  >
    <p v-if="showExitButton">
      Your session has expired.
    </p>
    <p v-else>
      You session is about to expire! Do you still need more time to use the application?
    </p>
    
    <h1>{{ formattedTime }}</h1>

    <br>

    <div class="ts-modal_actions">
      <button v-if="showExitButton"
        class="ts-btn ts-btn-secondary"
        :class="{ loading: btnLoading }"
        @click="endSession"
      >
        <i>
          <v-icon name="circle-notch" />
        </i>
        Exit
      </button>

      <button v-else
        class="ts-btn ts-btn-secondary"
        :class="{ loading: btnLoading }"
        @click="extendSession"
      >
        <i>
          <v-icon name="circle-notch" />
        </i>
        Yes
      </button>
    </div>
  </el-dialog>
</template>

<script>
import loginUtils from "@/utils/login.utils";
export default {
  name: "SessionUpdate",
  props: {
    showModal: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      timeLeft: 300, // 5 minutes in seconds,
      countdownInterval: null,
      btnLoading: false,
      showExitButton: false,
      isVisible: false,
      lastTimestamp: null,
     };
  },
  mounted() {
    // Event listeners for visibility change and window focus/blur
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('focus', this.handleWindowFocus);
    window.addEventListener('blur', this.handleWindowBlur);
  },
  beforeDestroy() {
    // Remove event listeners when the component is destroyed
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleWindowFocus);
    window.removeEventListener('blur', this.handleWindowBlur);
    clearInterval(this.countdownInterval); // Ensure the timer is stopped when the component is destroyed
  },
  computed: {
    currentUser() {
      return this.$store.state.account.current_user.id;
    },
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60);
      const seconds = Math.floor(this.timeLeft % 60);
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.startCountdown(300);
      }
    }
  },
  methods: {
    startCountdown(val) {
      this.showExitButton = false;
      this.timeLeft = val;

      this.lastTimestamp = Date.now();
      this.countdownInterval = setInterval(() => {
        const currentTime = Date.now();
        const deltaTime = (currentTime - this.lastTimestamp) / 1000; // in seconds
        this.timeLeft = Math.max(0, this.timeLeft - deltaTime);
        this.lastTimestamp = currentTime;
        if (this.timeLeft <= 0) {
          clearInterval(this.countdownInterval); // Clear interval when timer reaches 0
          this.showExitButton = true;
        }
      }, 1000);
    },
    endSession() {
      this.btnLoading = true;
      this.$store.dispatch("account/logout");
    },
    extendSession() {
      this.showExitButton = false;
      this.btnLoading = true;

      clearInterval(this.countdownInterval); // Clear interval when timer reaches 0
      
      this.$store.dispatch("account/extendSession", this.$store.state.account.current_user.id)
        .then((res) => {
          const timeOutTime = new Date().getTime() + (loginUtils.getSessionTimeoutInMilliseconds());
          localStorage.setItem('timeOutTime', timeOutTime);

          this.$message.success("Session updated successfully.");  
          //this.showModal = false;
          this.btnLoading = false;
          this.$emit("close-modal");
        });
    },
    handleVisibilityChange() {
      this.startCountdown(this.timeLeft);     
    },
    handleWindowFocus() {
      if (this.isVisible) {
        this.startCountdown(this.timeLeft);
      } else {
        this.startCountdown(this.timeLeft);
      }
    },
    handleWindowBlur() {
      this.startCountdown(this.timeLeft);
    }
  },
};
</script>